import { DialogActions } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { FoldersApi } from "../../../api/folders/folders";
import { useSnackbar } from "../../../data/SnackbarContext";
import { ARCHIVE_FOLDER_DIALOG, SNACKBAR_MESSAGES } from "../../../data/StringConstants";
import CustomButton from "../../CustomButton/CustomButton";

import analytics from "../../../utils/analytics";

/**
 * @description Archive Folder by ID
 * @param {number} folderId ID of folder to be archived
 * @param {function} toggle Supplied to the `cancel` button
 * @param {function} callback Function to execute at the end of the api call
 * @todo - the callback here would be useful to implement audit trails for FE metrics
 */
export default function ArchiveFolderDialogActions({ folderId, folderName, toggle, callback }) {
  const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar();

  const archiveFolder = async folderId => {
    try {
      analytics.logEvent(analytics.eventTypes.FOLDERS.ARCHIVE_FOLDER_CONFIRMATION_CLICKED, {
        folder: {
          id: folderId,
          name: folderName
        },
        cancelOrArchive: "archive"
      });

      const result = await FoldersApi.archiveFolder(folderId);

      if (result.status === 200) {
        showSuccessSnackbar(SNACKBAR_MESSAGES.ARCHIVE_FOLDER_SUCCESS);
        callback(result);
      }
    } catch (error) {
      showErrorSnackbar(SNACKBAR_MESSAGES.ARCHIVE_FOLDER_ERROR);
    }
  };

  const cancel = () =>
  {
    analytics.logEvent(analytics.eventTypes.FOLDERS.ARCHIVE_FOLDER_CONFIRMATION_CLICKED, {
      folder: {
        id: folderId,
        name: folderName
      },
      cancelOrArchive: "cancel"
    });
    toggle();
  };

  return <DialogActions>
    <CustomButton onClick={cancel}>
      {ARCHIVE_FOLDER_DIALOG.CANCEL_BTN}
    </CustomButton>
    <CustomButton
      color="secondary"
      variant="contained"
      onClick={() => { archiveFolder(folderId) }}
    >
      {ARCHIVE_FOLDER_DIALOG.ARCHIVE_BTN}
    </CustomButton>
  </DialogActions>
}

ArchiveFolderDialogActions.propTypes = {
  folderId: PropTypes.number.isRequired,
  folderName: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
}